import { gql } from '@apollo/client'

export const BULK_MARK_NOTIFICATIONS_READ = gql`
  mutation bulkMarkNotificationsRead($notificationIds: [ID!]!) {
    bulkMarkNotificationsRead(notificationIds: $notificationIds) {
      success
    }
  }
`
